import { Map, List } from "immutable";
import { STATE_STATUS } from "constants";
import {DB_ONBOARDING_ACTIONS} from 'constants/actions';

const INITIAL_STATE = new Map({
    status : STATE_STATUS.UNFETCHED,
    dbOnBoardingList : List(),
    count : null,
    deleteDocumentState : STATE_STATUS.UNFETCHED
});

export default (state = INITIAL_STATE, { type, payload, error }) => {
    switch (type) {
        case DB_ONBOARDING_ACTIONS.FETCH_DB_ONBOARDING_LIST:
            return state.set("status" , STATE_STATUS.FETCHING);

        case DB_ONBOARDING_ACTIONS.FETCHED_DB_ONBOARDING_LIST : 
            return state
                .set("status" , STATE_STATUS.FETCHED)
                .set('count' , payload.data['count'])
                .set("dbOnBoardingList" , List(payload.data['results']));

        case DB_ONBOARDING_ACTIONS.FAILED_FETCH_DB_ONBOARDING_LIST:
            return state.set("status" , STATE_STATUS.FETCH_FAILED);
        

        case DB_ONBOARDING_ACTIONS.FETCH_DB_ONBOARDING_VALIDATE_DOCUMENT:
            return state.set("deleteDocumentState" , STATE_STATUS.FETCHING);

        case DB_ONBOARDING_ACTIONS.FETCHED_DB_ONBOARDING_VALIDATE_DOCUMENT : 
            return state
                .set("deleteDocumentState" , STATE_STATUS.FETCHED)

        case DB_ONBOARDING_ACTIONS.FAILED_FETCH_DB_ONBOARDING_VALIDATE_DOCUMENT:
            return state.set("deleteDocumentState" , STATE_STATUS.FETCH_FAILED);
        
        case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
